export const pushGtmEvent = (eventName, payload = {}) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...payload,
  });
};

export const trackCallButtonClick = () => {
  pushGtmEvent('call_button_click');
};
